import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, ImageReveal } from "../components/Reveal";
import { IMAGES } from "../data/site";

const CHAPTERS = [
  {
    no: "01",
    title: "Born of the desert",
    body: "Desert Vibe Media began where the road ends — in the wide, patient silence of the dunes. That silence taught us to listen before we shoot, to find the story hiding in the heat haze.",
  },
  {
    no: "02",
    title: "The owl & the hawk",
    body: "Our tribal marks — the owl and the hawk — are more than a logo. The owl is our patience: watching, waiting for the truth. The hawk is our precision: decisive, exact, unmissable. Every film we make lives between the two.",
  },
  {
    no: "03",
    title: "Craft over noise",
    body: "We keep crews lean and intentions sharp. No excess, no filler — only the frames that earn their place. The result is work that feels inevitable, as if it could have been made no other way.",
  },
  {
    no: "04",
    title: "Your story is our business",
    body: "We do not sell footage. We build the story that makes people stop, feel, and remember your name. That is the whole business — and we take it personally.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="mx-auto max-w-7xl px-6 pb-16 pt-40 lg:px-10 lg:pt-48">
        <Reveal>
          <p className="overline text-sand-700">About the Studio</p>
          <h1 className="mt-6 max-w-4xl font-display text-6xl leading-[0.9] tracking-tight text-sand-100 md:text-8xl">
            Patience of the owl. Precision of the <span className="italic text-sand-700">hawk.</span>
          </h1>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-8 md:grid-cols-2">
          <ImageReveal src={IMAGES.bts} alt="Desert Vibe Media crew on a desert set at golden hour" className="aspect-[4/5]" />
          <ImageReveal src={IMAGES.canyon} alt="Red-rock canyon at golden hour" className="aspect-[4/5] md:mt-24" />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40" data-testid="manifesto">
        <div className="space-y-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no}>
              <div className="grid gap-8 border-t border-border pt-10 md:grid-cols-12" data-testid={`chapter-${c.no}`}>
                <div className="md:col-span-5">
                  <span className="font-display text-7xl italic text-sand-700 md:text-8xl">{c.no}</span>
                  <h2 className="mt-4 font-display text-4xl text-sand-100 md:text-5xl">{c.title}</h2>
                </div>
                <div className="md:col-span-6 md:col-start-7">
                  <p className="font-body text-lg font-light leading-relaxed text-sand-400">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-24">
          <Link to="/contact"><span className="btn-desert" data-testid="about-cta">Work with us <ArrowUpRight size={16} /></span></Link>
        </Reveal>
      </section>
    </div>
  );
}
